<template>
    <div class="footer" :class="current_articles.length > 0 ? 'active' : ''">
        <ul class="nav">
            <li class="nav-item"><button class="btn btn-default" @click="navigate('/', 1)">Start</button></li>
            <li class="nav-item"><button class="btn btn-default" @click="navigate('Articles', 2)">Artikel</button></li>
            <li class="nav-item"><button class="btn btn-default" @click="navigate('Address', 3)">Adresse</button></li>
            <li class="nav-item"><button class="btn btn-default" @click="navigate('Summary', 4)">Zusammenfassung</button></li>
        </ul>
    </div>

</template>

<script>
import router from '@/router/index';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "Footer",
    computed: {
        ...mapGetters('orders', ['current_articles']),
    },
    methods: {
        ...mapActions("orders", [
            "navigate"
        ]),
        navigate(route_name, step) {
            router.push(route_name);
            this.$store.dispatch("orders/navigate", step);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>